{
  "aria.profileImage": "Profile Image",
  "chooseIndustries": "Choose industries",
  "chooseIndustriesText": "Choose industries your clients of companies work with/within",
  "heading": "Provider Profile",
  "edit": "Edit",
  "editProfile": "Edit profile",
  "editActorProfile": "Edit actor profile",
  "firstLineService": "First line service for",
  "generalInfo.commonEmail": "Common e-mail",
  "generalInfo.heading": "General information",
  "generalInfo.optional": "We recommend filling in as many fields as possible to increase the visibility of the organization.",
  "logo": "Logo",
  "mainContact": "Primary Contact",
  "update": "Oppdater aktørprofil",
  "update.success": "Actorprofile updated",
  "update.failure.heading": "We couldn't update the actor profile",
  "update.failure.text": "Control the form fields and try again, or contact us at",
  "noActor": "No actor information was found",
  "noDescription": "No description has been added yet",
  "noDescription.cta": "Other actors cannot see your description",
  "noLogo": "No logo has been uploaded",
  "noMainContact": "No primary contact has been added",
  "noIndustry": "No industry has been added",
  "portfolioIndustries": "Industries in your portfolio",
  "services": "Services",
  "goToCatalog": "Go to service catalog",
  "workAreas": "Work Areas",
  "showProfile": "Show profile",
  "loggedInAs": "You are logged in as {{ user }} for {{ actor }}.",
  "addViaAccessControl": "Can't find an employe or want to update their information? You can add new employees or update information in ",
  "informationSaved": "Information saved",
  "employeePhoto": "Employee photo",
  "mainContactPhoto": "Primary contact photo",
  "actorLogo": "Actor logo",
  "services.readMore": "Read more about the services",
  "companyAgeRequirement": "Company age requirements",
  "companySize": "Company size requirements",
  "commonServiceCatalogue": "Common service catalogue",
  "noServices": "No services available, register services in",
  "name": "Name",
  "phone": "Phone",
  "email": "E-mail",
  "contactPerson": "Contact person",
  "required.address": "Address is required",
  "required.postalCode": "Postal code is required and must be a four-digit number"
}
